export default "__VITE_ASSET__B5rYPt6P__"